import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BzSkeletonShape = 'text' | 'circle' | 'rect';

/**
 * A placeholder shape shown while real content is loading. Replaces the
 * console's `app-card-skeleton`, which drew a fixed number of grey bars —
 * `bz-skeleton` is one shape, so a loading layout is composed from several
 * the same way the real content will be.
 *
 * Purely decorative: the host is `aria-hidden`, and the shimmer respects
 * `prefers-reduced-motion` in the stylesheet. The surrounding container is
 * responsible for `aria-busy` / a "loading" label — a shape has nothing
 * meaningful to announce on its own.
 */
@Component({
  selector: 'bz-skeleton',
  template: '',
  styleUrl: './bz-skeleton.scss',
  host: {
    '[class]': 'hostClass()',
    '[style.inline-size]': 'width()',
    '[style.block-size]': 'shape() === "text" ? null : height()',
    'aria-hidden': 'true',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzSkeleton {
  readonly shape = input<BzSkeletonShape>('text');
  readonly width = input<string>('100%');
  readonly height = input<string>('40px');

  protected readonly hostClass = computed(() => `bz-skeleton bz-skeleton--${this.shape()}`);
}
